<template>
  <div class="container-fluid new-template-form">
    <vx-card>
      <h1 v-if="!editMode" class="mb-8">Nueva plantilla</h1>
      <h1 v-if="editMode" class="mb-8">Editar plantilla</h1>
      <div class="vx-row">
        <div :class="colClass">
          <vs-input class="w-full" label="Nombre de la plantilla" name="tname" v-model.lazy="template.name"
            :placeholder="placeholder" />
        </div>
        <div :class="colClass">
          <vs-input class="w-full" label="Descripción" name="tdesc" v-model.lazy="template.description"
            :placeholder="placeholder" />
        </div>
        <div :class="colClass">
          <label for="types">Tipo de molde (ID: {{ template.moldId }}) <span class="text-primary">*</span></label>
          <v-select name="types" class="vs-custom" :placeholder="selectPlaceholder" v-model.lazy="template.moldId"
            :options="mold.options" label="label" :clearable="false" :searchable="false" :reduce="item => item.value">
          </v-select>
        </div>

        <vs-divider v-if="template.moldId !== 0">PLANTILLA</vs-divider>

        <div class="vx-col w-full" v-if="template.moldId !== 0">
          <div class="jumbotron p-5 mb-2">
            <h1 class="display-4">{{ template.moldId }} | {{ getMoldName(template.moldId) }}</h1>
            <h5 class="m-0">Valores dinamicos:</h5>
            <ul class="list-group">
              <li class="list-group-item" v-for="(element, iKey) in mold.dynamic[template.moldId]" v-bind:key="iKey">
                <strong>{{ iKey }}</strong> <span class="dynamic-space">:</span> <span
                  v-html="$sanitizeHtml(element.description)"></span>
              </li>
            </ul>
          </div>
        </div>
        <div class="m-4 w-full" v-if="template.moldId == 1">
          <UnoForm v-model.lazy="form" />
        </div>
        <div class="m-4 w-full" v-if="template.moldId == 2">
          <DosForm v-model.lazy="form" />
        </div>
        <div class="m-4 w-full" v-if="template.moldId == 3">
          <TresForm v-model.lazy="form" />
        </div>
        <div class="m-4 w-full" v-if="template.moldId == 4">
          <FreeHtmlForm v-model.lazy="form"></FreeHtmlForm>
        </div>
        <div v-if="template.moldId == 5">
          Cinco
        </div>
        <br>
        <!-- <div class="col-5">
          <code>Live preview (beta 14.03.22). Not final e-mail.</code>
          <div v-if="template.moldId==1">
            <UnoTemplate v-model.lazy="form" />
          </div>
          <div v-if="template.moldId==2">
            <DosTemplate v-model.lazy="form" />
          </div>
          <div v-if="template.moldId==3">
            <TresTemplate v-model.lazy="form" />
          </div>
          <div v-if="template.moldId==4">
            <br><h1>Coming soon...</h1>
          </div>
          <div v-if="template.moldId==5">
            <br><h1>Coming soon...</h1>
          </div>
        </div> -->
      </div>
      <div>
        <vs-button v-if="!editMode" class="mt-3" @click="createTemplate()" color='success'>
          Guardar
        </vs-button>
        <vs-button v-else class="mt-3" @click="editTemplate()">
          Actualizar
        </vs-button>
      </div>
    </vx-card>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import UnoForm from "@views/admin/emails/Templates/Mold/Uno/UnoForm";
import UnoTemplate from "@views/admin/emails/Templates/Mold/Uno/UnoTemplate";
import DosForm from "@views/admin/emails/Templates/Mold/Dos/DosForm";
import DosTemplate from "@views/admin/emails/Templates/Mold/Dos/DosTemplate";
import TresForm from "@views/admin/emails/Templates/Mold/Tres/TresForm";
import TresTemplate from "@views/admin/emails/Templates/Mold/Tres/TresTemplate";
import FreeHtmlForm from "@views/admin/emails/Templates/Mold/FreeHTML/FreeHtmlForm.vue";

export default {
  name: "Form",
  components: {
    Datepicker,
    UnoForm,
    UnoTemplate,
    DosForm,
    DosTemplate,
    TresForm,
    TresTemplate,
    FreeHtmlForm
  },
  data: () => ({
    colClass: "vx-col sm:w-full md:w-1/2 lg:w-1/3 mb-5",
    placeholder: "(Requerido)",
    selectPlaceholder: "Selecciona una opción",
    mold: {
      options: [
        { value: 1, label: "Banner, !Hola <user.name>!, Subject, Text, Button" },
        { value: 2, label: "Full Image, Button" },
        { value: 3, label: "Full Image" },
        { value: 4, label: "Free HTML" },
      ],
      dynamic: {
        1: {
          '<<1>>': {
            ref: 'user.name',
            description: `Será sustituido por el <strong>nombre del usuario</strong> al enviar el correo electrónico.`,
          }
        },
        2: {
          'Ninguno': {
            ref: '-',
            description: `Sin valores dinamicos`,
          }
        },
        3: {
          'Ninguno': {
            ref: '-',
            description: `Sin valores dinamicos`,
          }
        },
        4: {
          'Ninguno': {
            ref: '-',
            description: `Sin valores dinamicos`,
          }
        }
      }
    },
    template: {
      id: '',
      moldId: 0,
      name: '',
      description: '',
      jsonStringify: '',
    },
    form: {},
  }),
  props: {
    editMode: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    async createTemplate() {
      this.template.jsonStringify = JSON.stringify(this.form);
      try {
        this.showLoading(true);
        await axios.post(`/api/app-http-services/services/notifications/email/templates`, this.template)
        this.$emit("updated");
        this.showLoading(false);
        this.saveSuccessNotif();
      } catch (e) {
        this.showLoading(false);
        if (e.response.status === 422) {
          await swal("Notificación", JSON.stringify(e.response.data.errors), "warning")
        }
        if (e.response.status === 500) {
          await swal("Error", "Hubo un error al guardar el template", "error")
        }
      }
      this.showLoading(false);
    },
    async editTemplate() {
      this.template.jsonStringify = JSON.stringify(this.form);
      try {
        this.showLoading(true);
        await axios.put(`/api/app-http-services/services/notifications/email/templates/${this.template.id}`, this.template)

        this.showLoading(false);
        this.saveSuccessNotif();
        await this.$emit("updated");
      } catch (e) {
        this.showLoading(false);
        if (e.response.status === 422) {
          await swal("Notificación", JSON.stringify(e.response.data.errors), "warning")
        }
        if (e.response.status === 500) {
          await swal("Error", "Hubo un error al actualizar el template", "error")
        }
      }
    },
    getMoldName(id) {
      let mold =  this.mold.options.find(x => x.value == id);
      return mold != null ? mold.label : "NA";
    }
  }
}
</script>

<style>
strong {
  margin: 0 !important;
}

.dynamic-space {
  padding: 0 5px;
}
</style>